import React from 'react';
import {Button, Grid, Header, Icon, Input, Modal} from 'semantic-ui-react';
import _ from "lodash";
import {socket} from "../../../lib/socketio";
import {isAuthorized } from '../../../lib/authorization';
import { useSelector } from 'react-redux';
import {createUserLog} from "../../../lib/api";

const convertValue =(value, name) => {
    if(typeof value === 'undefined'){
        return '';
    }

    if(name === 'IORack5Status' || name === 'IORack6Status' || name === 'LOI Shutdown' ||
            name === 'LOR Enable' || name === 'Cust Norm SD' )
    {
        if(value === 1){
            return 'SD';
        }
        else{
            return 'OK'
        }
    }
    else if(name === 'GFD_Bender'){
        if(value === 1){
            return 'FAULT'
        }
        else{
            return 'OK'
        }
    }
    else if(name === 'CV451' || name ==='CV560' || name === 'CV012' || name ==='CV014' || name==='CV105' || name==='CV140' ||  name==='CV380' 
            || name === 'CV511' || name ==='CV150' || name ==='CV510' || name === 'CV720' || name === 'ZS014' || name === 'CV710' || name === 'CV030' || name === 'CV031' 
            || name === 'CV140' || name === 'CV020_STATUS' || name === 'CV011' || name === 'CV021' || name === 'CV022' || name === 'CV400' || name === 'CV401' || name === 'CV711' || name === 'CV713'
            ){
        // normal open : 250305, CV720, CV710, CV713, CLD001~CLD003
        if(name === 'CV720' || name === 'CV710' || name === 'CV713'){
            if(value===0){
                return 'OPEN';
            }
            else return 'CLOSED';
        }
        else {
            if(value === 1){
                return 'OPEN'
            }
            else{  
                return 'CLOSED'
            }
        }

    }
    else{
        // update 241028, CLD STATUS - marine only
        // update 250217 CLD Status normal open - S300 CLD001~003 CMD, CLD001STATUS ~ CLD003STATUS
        // update 250513, CLD001STATUS~CLD003STATUS (MAIN tag) normal open 처리 
        if(name === 'P1CLD001STATUS' || name === 'P1CLD002STATUS' || name === 'P1CLD003STATUS' ||
            name === 'P2CLD001STATUS' || name === 'P2CLD002STATUS' || name === 'P2CLD003STATUS' ||
            name === 'P3CLD001STATUS' || name === 'P3CLD002STATUS' || name === 'P3CLD003STATUS' ||
            name === 'P4CLD001STATUS' || name === 'P4CLD002STATUS' || name === 'P4CLD003STATUS' ||
            name === 'P5CLD001STATUS' || name === 'P5CLD002STATUS' || name === 'P5CLD003STATUS' ||
            name === 'MAIN CLD001 STATUS' || name === 'MAIN CLD002 STATUS' || name === 'MAIN CLD003 STATUS'  
            ){
            if(value===0){
                return 'ON';
            }
            else return 'OFF';
        }
        else {
            if(value === 1){
                return 'ON'
            }
            else{
                return 'OFF'
            }
        }

        
    }
}

const IOColumn = ({ index, column, option, data, title, ovrdata, parentCallback, tags, settags, tempovrdata, settempovrdata, tempoverridden, settempoverriden, isCopied, setIsCopied, dataCopy, setDataCopy, currentPLC}) => {

    const [tagdata, settagdata]= React.useState('');
    const [checkdata, setcheckdata]= React.useState('');
    const [open,setOpen]= React.useState(false);
    const [overrideVisible, setOverrideVisible] = React.useState({'visible': true});
    // const [runstop380Alarm, setRunStop380Alarm] = React.useState('');
    // const [runstop110Alarm, setRunStop110Alarm] = React.useState('');

    // update SOFC 2403xx by sumin, add alarm messge CV380 must be open / CV110 must be open when each blo380runstop/blo110runstop is on 
    // const [PSM1runstop380Alarm, setPSM1RunStop380Alarm] = React.useState('');
    // const [PSM2runstop380Alarm, setPSM2RunStop380Alarm] = React.useState('');    
    // const [PSM3runstop380Alarm, setPSM3RunStop380Alarm] = React.useState('');
    // const [PSM4runstop380Alarm, setPSM4RunStop380Alarm] = React.useState('');
    // const [PSM5runstop380Alarm, setPSM5RunStop380Alarm] = React.useState('');
    
    const [PSM1runstop110Alarm, setPSM1RunStop110Alarm] = React.useState('');
    const [PSM2runstop110Alarm, setPSM2RunStop110Alarm] = React.useState('');
    const [PSM3runstop110Alarm, setPSM3RunStop110Alarm] = React.useState('');
    const [PSM4runstop110Alarm, setPSM4RunStop110Alarm] = React.useState('');
    const [PSM5runstop110Alarm, setPSM5RunStop110Alarm] = React.useState('');
    const user = useSelector(state => state.nav.user);
    const ppid = useSelector(state => state.header.ppid);
    const electronApp = useSelector(state => state.nav.electronApp);
    
    const CheckOnOp =(name) => {
        if(name === 'IORack5Status' || name === 'IORack6Status' || name === 'LOI Shutdown' ||
            name === 'LOR Enable' || name === 'Cust Norm SD' )
        {
            return 'SD';
        }
        else if(name === 'GFD_Bender'){
            return 'FAULT';
        }
        else if(name === 'CV451' || name ==='CV560' || name === 'CV012' || name ==='CV014' || name==='CV105' || name==='CV140' ||  name==='CV380' 
        || name === 'CV511' || name ==='CV150' || name ==='CV510' || name === 'CV720' || name === 'ZS014' || name === 'CV710' || name === 'CV030' || name === 'CV031'
        || name === 'CV140' || name === 'CV020_STATUS' || name === 'CV011' || name === 'CV021' || name === 'CV022' || name === 'CV400' || name === 'CV401' || name === 'CV711' 
        || name === 'CV713'
        ){
            return 'OPEN';
        }
        else{
           return 'ON';
        }
    }

    const CheckOffOp =(name) => {
        if(name === 'IORack5Status' || name === 'IORack6Status' || name === 'LOI Shutdown' ||
            name === 'LOR Enable' || name === 'Cust Norm SD' || name === 'GFD_Bender' )
        {
            return 'OK';
        }
        else if(name === 'CV451' || name ==='CV560' || name === 'CV012' || name ==='CV014' || name==='CV105' || name==='CV140' ||  name==='CV380' 
        || name === 'CV511' || name ==='CV150' || name ==='CV510' || name === 'CV720' || name === 'ZS014' || name === 'CV710' || name === 'CV030' || name === 'CV031'
        || name === 'CV140' || name === 'CV020_STATUS' || name === 'CV011' || name === 'CV021' || name === 'CV022' || name === 'CV400' || name === 'CV401' || name === 'CV711' || name === 'CV713'
        ){
            return 'CLOSED';
        }
        else{
            return 'OFF';
        }
    }

    React.useEffect(() => {
        let interval = setInterval(setOverrideVisiblity, 400);
        return() => clearInterval(interval);
    }, [overrideVisible]); // eslint-disable-line react-hooks/exhaustive-deps

    const setOverrideVisiblity = () => {
        setOverrideVisible({...overrideVisible, 'visible': !overrideVisible.visible});
    }

    const handleOpen = (id) => {
        setOpen({...open, [id]:true});
    };

    // console.log(currentPLC);

    const handleClose = (id) => {
        // update SOFC, add alarm messge CV380 must be open / CV110 must be open, by sumin 2403xx
        setPSM1RunStop110Alarm('');
        setPSM2RunStop110Alarm('');
        setPSM3RunStop110Alarm('');
        setPSM4RunStop110Alarm('');
        setPSM5RunStop110Alarm('');
        // setPSM1RunStop380Alarm('');
        // setPSM2RunStop380Alarm('');
        // setPSM3RunStop380Alarm('');
        // setPSM4RunStop380Alarm('');
        // setPSM5RunStop380Alarm('');

        settagdata('');
        
        if(typeof dataCopy !== 'undefined' && (id in dataCopy)){
            delete dataCopy[id];
        }
        setcheckdata('');
        setOpen({...open, [id]:false});
    };

    const handleToggle = (event, id) => {
        event.preventDefault();
        var datavalue;

        if(typeof tagdata === 'undefined' || tagdata === ''){
            datavalue = data[id];
        }
        else datavalue = tagdata;                                                                                                                                                                                                                                                

        var writedata = {'tag_id':id, 'tag_value': datavalue, 'isOverriden': 1};
        var index = ovrdata.findIndex(x => x.tag_id === id);

        if(typeof ovrdata[index] === 'undefined') {
            ovrdata.push(writedata);
        }
        else {
            ovrdata[index] = {'tag_id':id, 'tag_value': datavalue, 'isOverriden': 1};
        }
        
        settempoverriden({...tempoverridden, [id]: 1});
        settempovrdata({...tempovrdata, [id]: datavalue});
        setOpen({...open, [id]:false});
        settagdata('');
    }

    const handleDigToggle = (event, id, currentPLC) => {
        event.preventDefault();
        var boolvalue;
        if (typeof checkdata === 'undefined' || checkdata === '') {
            boolvalue = data[id];
        } else {
            boolvalue = checkdata;
        }

        // !TODO : PSM별로 다 필요함, currentPLC 값으로 구분 필요함 
        if (id === 30448 || id === 30451) { // * CV711, CV713 -> 동시에 둘이 같이 동작해야하는 케이스에 적용
            var writedata1 = {'tag_id': 30448, 'tag_value': boolvalue, 'isOverriden': 1};
            var writedata2 = {'tag_id': 30451, 'tag_value': boolvalue, 'isOverriden': 1};
            var index1 = ovrdata.findIndex(x => x.tag_id === 30448);
            var index2 = ovrdata.findIndex(x => x.tag_id === 30451);
            if(typeof ovrdata[index1] === 'undefined' && typeof ovrdata[index2] === 'undefined') {
                ovrdata.push(writedata1, writedata2);
            }
            else {
                ovrdata[index1] = {'tag_id': 30448, 'tag_value': boolvalue, 'isOverriden': 1} ;
                ovrdata[index2] = {'tag_id': 30451, 'tag_value': boolvalue, 'isOverriden': 1} ;
            }
            settempoverriden({...tempoverridden, 30448: 1, 30451: 1});
            settempovrdata({...tempovrdata, 30448: boolvalue, 30451: boolvalue});

        }  else if (id === 31855 || id === 31858) { // * CV711, CV713 -> 동시에 둘이 같이 동작해야하는 케이스에 적용
            var writedata1 = {'tag_id': 31855, 'tag_value': boolvalue, 'isOverriden': 1};
            var writedata2 = {'tag_id': 31858, 'tag_value': boolvalue, 'isOverriden': 1};
            var index1 = ovrdata.findIndex(x => x.tag_id === 31855);
            var index2 = ovrdata.findIndex(x => x.tag_id === 31858);
            if(typeof ovrdata[index1] === 'undefined' && typeof ovrdata[index2] === 'undefined') {
                ovrdata.push(writedata1, writedata2);
            }
            else {
                ovrdata[index1] = {'tag_id': 31855, 'tag_value': boolvalue, 'isOverriden': 1} ;
                ovrdata[index2] = {'tag_id': 31858, 'tag_value': boolvalue, 'isOverriden': 1} ;
            }
            settempoverriden({...tempoverridden, 31855: 1, 31858: 1});
            settempovrdata({...tempovrdata, 31855: boolvalue, 31858: boolvalue});

        }  else if (id === 33262 || id === 33265) { // * CV711, CV713 -> 동시에 둘이 같이 동작해야하는 케이스에 적용
            var writedata1 = {'tag_id': 33262, 'tag_value': boolvalue, 'isOverriden': 1};
            var writedata2 = {'tag_id': 33265, 'tag_value': boolvalue, 'isOverriden': 1};
            var index1 = ovrdata.findIndex(x => x.tag_id === 33262);
            var index2 = ovrdata.findIndex(x => x.tag_id === 33265);
            if(typeof ovrdata[index1] === 'undefined' && typeof ovrdata[index2] === 'undefined') {
                ovrdata.push(writedata1, writedata2);
            }
            else {
                ovrdata[index1] = {'tag_id': 33262, 'tag_value': boolvalue, 'isOverriden': 1} ;
                ovrdata[index2] = {'tag_id': 33265, 'tag_value': boolvalue, 'isOverriden': 1} ;
            }
            settempoverriden({...tempoverridden, 33262: 1, 33265: 1});
            settempovrdata({...tempovrdata, 33262: boolvalue, 33265: boolvalue});

        }  else if (id === 34669 || id === 34672) { // * CV711, CV713 -> 동시에 둘이 같이 동작해야하는 케이스에 적용
            var writedata1 = {'tag_id': 34669, 'tag_value': boolvalue, 'isOverriden': 1};
            var writedata2 = {'tag_id': 34672, 'tag_value': boolvalue, 'isOverriden': 1};
            var index1 = ovrdata.findIndex(x => x.tag_id === 34669);
            var index2 = ovrdata.findIndex(x => x.tag_id === 34672);
            if(typeof ovrdata[index1] === 'undefined' && typeof ovrdata[index2] === 'undefined') {
                ovrdata.push(writedata1, writedata2);
            }
            else {
                ovrdata[index1] = {'tag_id': 34669, 'tag_value': boolvalue, 'isOverriden': 1} ;
                ovrdata[index2] = {'tag_id': 34672, 'tag_value': boolvalue, 'isOverriden': 1} ;
            }
            settempoverriden({...tempoverridden, 34669: 1, 34672: 1});
            settempovrdata({...tempovrdata, 34669: boolvalue, 34672: boolvalue});

        }  else if (id === 36076 || id === 36079) { // * CV711, CV713 -> 동시에 둘이 같이 동작해야하는 케이스에 적용
            var writedata1 = {'tag_id': 36076, 'tag_value': boolvalue, 'isOverriden': 1};
            var writedata2 = {'tag_id': 36079, 'tag_value': boolvalue, 'isOverriden': 1};
            var index1 = ovrdata.findIndex(x => x.tag_id === 36076);
            var index2 = ovrdata.findIndex(x => x.tag_id === 36079);
            if(typeof ovrdata[index1] === 'undefined' && typeof ovrdata[index2] === 'undefined') {
                ovrdata.push(writedata1, writedata2);
            }
            else {
                ovrdata[index1] = {'tag_id': 36076, 'tag_value': boolvalue, 'isOverriden': 1} ;
                ovrdata[index2] = {'tag_id': 36079, 'tag_value': boolvalue, 'isOverriden': 1} ;
            }
            settempoverriden({...tempoverridden, 36076: 1, 36079: 1});
            settempovrdata({...tempovrdata, 36076: boolvalue, 36079: boolvalue});
        }  else {
            var writedata = {'tag_id': id, 'tag_value': boolvalue, 'isOverriden': 1};
            var index = ovrdata.findIndex(x => x.tag_id === id);
            if(typeof ovrdata[index] === 'undefined') {
                ovrdata.push(writedata);
            }
            else {
                ovrdata[index] = {'tag_id': id, 'tag_value': boolvalue, 'isOverriden': 1} ;
            }
            settempoverriden({...tempoverridden, [id]: 1});
            settempovrdata({...tempovrdata, [id]: boolvalue});
        }
        setOpen({...open, [id]: false});
        setcheckdata('');
    }

    const handleClear =(event, id) => {
        event.preventDefault();
        var adiodata = {'buttonClickType': 'Clear Individual Analog Overrides', 'tags': [id]};
        socket.emit('button click', adiodata);
        delete tempovrdata[id];
        delete tempoverridden[id];
        setOpen({...open, [id]:false});
        settags([...tags]);
        var index = ovrdata.findIndex(x => x.tag_id === id);
        if (index >= 0) {
            ovrdata.splice( index, 1 );
        }
        var col_idx = column[0].findIndex(x => x.id === id);
        column[0][col_idx].isOverriden = 0;
        if (!electronApp) {
            let log = {
                user_id: user.id,
                powerplant_id: ppid,
                display_id: null,
                datetime: new Date().toISOString(),
                data: JSON.stringify({
                    tags: [id],
                    type: "Clear Individual Override",
                }),
            };
            createUserLog({ log }).catch(console.error);
        }
    }

    // TODO : CV711, CV713 아래 코드 적용 + normal open 적용해야함 
    const handleDigClear =(event, id, currentPLC) => {
        event.preventDefault();
        if(id === 30448 || id === 30451){
            let adiodata = {'buttonClickType': 'Clear Individual Digital Overrides', 'tags': [30448,30451]}
            socket.emit('button click', adiodata);
            delete tempovrdata[30448];
            delete tempovrdata[30451];
            delete tempoverridden[30448];
            delete tempoverridden[30451];
            if(typeof dataCopy !== 'undefined' && (30448 in dataCopy || 30451 in dataCopy)){
                delete dataCopy[30448];
                delete dataCopy[30451];
            }

            setOpen({...open, [id]:false});
            settags([...tags]);
            var index1 = ovrdata.findIndex(x => x.tag_id === 30448);
            var index2 = ovrdata.findIndex(x => x.tag_id === 30451);
            var idsToRemove = [index1, index2];
            for (let j = idsToRemove.length -1; j >= 0; j--){
                ovrdata.splice(idsToRemove[j],1);
            }
            var col_idx1 = column[0].findIndex(x => x.id === 30448);
            var col_idx2 = column[0].findIndex(x => x.id === 30451);
            column[0][col_idx1].isOverriden = 0;
            column[0][col_idx2].isOverriden = 0;
            if (!electronApp) {
                let log = {
                    user_id: user.id,
                    powerplant_id: ppid,
                    display_id: null,
                    datetime: new Date().toISOString(),
                    data: JSON.stringify({
                        tags: [7792, 7800],
                        type: "Clear Individual Override",
                    }),
                };
                createUserLog({ log }).catch(console.error);
            }
            // setIsCopied(false);
        } else if (id === 31855 || id === 31858){
            let adiodata = {'buttonClickType': 'Clear Individual Digital Overrides', 'tags': [31855,31858]}
            socket.emit('button click', adiodata);
            delete tempovrdata[31855];
            delete tempovrdata[31858];
            delete tempoverridden[31855];
            delete tempoverridden[31858];
            if(typeof dataCopy !== 'undefined' && (31855 in dataCopy || 31858 in dataCopy)){
                delete dataCopy[31855];
                delete dataCopy[31858];
            }

            setOpen({...open, [id]:false});
            settags([...tags]);
            var index1 = ovrdata.findIndex(x => x.tag_id === 31855);
            var index2 = ovrdata.findIndex(x => x.tag_id === 31858);
            var idsToRemove = [index1, index2];
            for (let j = idsToRemove.length -1; j >= 0; j--){
                ovrdata.splice(idsToRemove[j],1);
            }
            var col_idx1 = column[0].findIndex(x => x.id === 31855);
            var col_idx2 = column[0].findIndex(x => x.id === 31858);
            column[0][col_idx1].isOverriden = 0;
            column[0][col_idx2].isOverriden = 0;
            if (!electronApp) {
                let log = {
                    user_id: user.id,
                    powerplant_id: ppid,
                    display_id: null,
                    datetime: new Date().toISOString(),
                    data: JSON.stringify({
                        tags: [7792, 7800],
                        type: "Clear Individual Override",
                    }),
                };
                createUserLog({ log }).catch(console.error);
            }
            // setIsCopied(false);


        } else if (id === 33262 || id === 33265){
            let adiodata = {'buttonClickType': 'Clear Individual Digital Overrides', 'tags': [33262,33265]}
            socket.emit('button click', adiodata);
            delete tempovrdata[33262];
            delete tempovrdata[33265];
            delete tempoverridden[33262];
            delete tempoverridden[33265];
            if(typeof dataCopy !== 'undefined' && (33262 in dataCopy || 33265 in dataCopy)){
                delete dataCopy[33262];
                delete dataCopy[33265];
            }

            setOpen({...open, [id]:false});
            settags([...tags]);
            var index1 = ovrdata.findIndex(x => x.tag_id === 33262);
            var index2 = ovrdata.findIndex(x => x.tag_id === 33265);
            var idsToRemove = [index1, index2];
            for (let j = idsToRemove.length -1; j >= 0; j--){
                ovrdata.splice(idsToRemove[j],1);
            }
            var col_idx1 = column[0].findIndex(x => x.id === 33262);
            var col_idx2 = column[0].findIndex(x => x.id === 33265);
            column[0][col_idx1].isOverriden = 0;
            column[0][col_idx2].isOverriden = 0;
            if (!electronApp) {
                let log = {
                    user_id: user.id,
                    powerplant_id: ppid,
                    display_id: null,
                    datetime: new Date().toISOString(),
                    data: JSON.stringify({
                        tags: [7792, 7800],
                        type: "Clear Individual Override",
                    }),
                };
                createUserLog({ log }).catch(console.error);
            }
            // setIsCopied(false);


        } else if (id === 34669 || id === 34672){
            let adiodata = {'buttonClickType': 'Clear Individual Digital Overrides', 'tags': [34669,34672]}
            socket.emit('button click', adiodata);
            delete tempovrdata[34669];
            delete tempovrdata[34672];
            delete tempoverridden[34669];
            delete tempoverridden[34672];
            if(typeof dataCopy !== 'undefined' && (34669 in dataCopy || 34672 in dataCopy)){
                delete dataCopy[34669];
                delete dataCopy[34672];
            }

            setOpen({...open, [id]:false});
            settags([...tags]);
            var index1 = ovrdata.findIndex(x => x.tag_id === 34669);
            var index2 = ovrdata.findIndex(x => x.tag_id === 34672);
            var idsToRemove = [index1, index2];
            for (let j = idsToRemove.length -1; j >= 0; j--){
                ovrdata.splice(idsToRemove[j],1);
            }
            var col_idx1 = column[0].findIndex(x => x.id === 34669);
            var col_idx2 = column[0].findIndex(x => x.id === 34672);
            column[0][col_idx1].isOverriden = 0;
            column[0][col_idx2].isOverriden = 0;
            if (!electronApp) {
                let log = {
                    user_id: user.id,
                    powerplant_id: ppid,
                    display_id: null,
                    datetime: new Date().toISOString(),
                    data: JSON.stringify({
                        tags: [7792, 7800],
                        type: "Clear Individual Override",
                    }),
                };
                createUserLog({ log }).catch(console.error);
            }
            // setIsCopied(false);


        }else if (id === 36076 || id === 36079){
            let adiodata = {'buttonClickType': 'Clear Individual Digital Overrides', 'tags': [36076,36079]}
            socket.emit('button click', adiodata);
            delete tempovrdata[36076];
            delete tempovrdata[36079];
            delete tempoverridden[36076];
            delete tempoverridden[36079];
            if(typeof dataCopy !== 'undefined' && (36076 in dataCopy || 36079 in dataCopy)){
                delete dataCopy[36076];
                delete dataCopy[36079];
            }

            setOpen({...open, [id]:false});
            settags([...tags]);
            var index1 = ovrdata.findIndex(x => x.tag_id === 36076);
            var index2 = ovrdata.findIndex(x => x.tag_id === 36079);
            var idsToRemove = [index1, index2];
            for (let j = idsToRemove.length -1; j >= 0; j--){
                ovrdata.splice(idsToRemove[j],1);
            }
            var col_idx1 = column[0].findIndex(x => x.id === 36076);
            var col_idx2 = column[0].findIndex(x => x.id === 36079);
            column[0][col_idx1].isOverriden = 0;
            column[0][col_idx2].isOverriden = 0;
            if (!electronApp) {
                let log = {
                    user_id: user.id,
                    powerplant_id: ppid,
                    display_id: null,
                    datetime: new Date().toISOString(),
                    data: JSON.stringify({
                        tags: [7792, 7800],
                        type: "Clear Individual Override",
                    }),
                };
                createUserLog({ log }).catch(console.error);
            }
            // setIsCopied(false);

            
        } else{
            let adiodata = {'buttonClickType': 'Clear Individual Digital Overrides', 'tags': [id]};
            socket.emit('button click', adiodata);
            delete tempovrdata[id];
            delete tempoverridden[id];
            if(typeof dataCopy !== 'undefined' && id in dataCopy){
                delete dataCopy[id];
            }

            setOpen({...open, [id]:false});
            settags([...tags]);
            var index = ovrdata.findIndex(x => x.tag_id === id);
            if (index >= 0) {
                ovrdata.splice( index, 1 );
            }
            var col_idx = column[0].findIndex(x => x.id === id);
            column[0][col_idx].isOverriden = 0;
            if (!electronApp) {
                let log = {
                    user_id: user.id,
                    powerplant_id: ppid,
                    display_id: null,
                    datetime: new Date().toISOString(),
                    data: JSON.stringify({
                        tags: [7792, 7800],
                        type: "Clear Individual Override",
                    }),
                };
                createUserLog({ log }).catch(console.error);
            }
            // setIsCopied(false);
        }
    }

    const handleChange = (e, {value}) => {
        settagdata(e.target.value);
    }

    // [UPDATE] override enterkey, 250703
    const handleSubmit = (event, id) => {
        event.preventDefault();
        var datavalue;

        if(typeof tagdata === 'undefined' || tagdata === ''){
            datavalue = data[id];
        }
        else datavalue = tagdata;                                                                                                                                                                                                                                                

        var writedata = {'tag_id':id, 'tag_value': datavalue, 'isOverriden': 1};
        var index = ovrdata.findIndex(x => x.tag_id === id);

        if(typeof ovrdata[index] === 'undefined') {
            ovrdata.push(writedata);
        }
        else {
            ovrdata[index] = {'tag_id':id, 'tag_value': datavalue, 'isOverriden': 1};
        }
        
        settempoverriden({...tempoverridden, [id]: 1});
        settempovrdata({...tempovrdata, [id]: datavalue});
        setOpen({...open, [id]:false});
        settagdata('');
    }

    // update SOFC -> normal open 
    // update SOFC 250513, CLD001STATUS~CLD003STATUS normal open
    const handleCheck = (event, obj_key, name) => {
        if( event.target.id === "1") {
            if( obj_key === 10258 || obj_key === 10252 || obj_key === 30451 ||
                obj_key === 14172 || obj_key === 14166 || obj_key === 31858 ||
                obj_key === 18086 || obj_key === 18080 || obj_key === 33265 ||
                obj_key === 22000 || obj_key === 21994 || obj_key === 34672 ||
                obj_key === 25914 || obj_key === 25908 || obj_key === 36079 ||
                obj_key === 3680 || obj_key === 3683 || obj_key === 3686 || obj_key === 3689 || obj_key === 3692 || obj_key === 3695 ||
                obj_key === 3698 || obj_key === 3701 || obj_key === 3704 || obj_key === 3707 || obj_key === 3710 || obj_key === 3713 ||
                obj_key === 3716 || obj_key === 3719 || obj_key === 3722 ||
                obj_key === 30689 || obj_key === 30690 || obj_key === 30691 || obj_key === 32096 || obj_key === 32097 || obj_key === 32098 ||
                obj_key === 33503 || obj_key === 33504 || obj_key === 33505 || obj_key === 34910 || obj_key === 34911 || obj_key === 34912 ||
                obj_key === 36317 || obj_key === 36318 || obj_key === 36319
            ){ // * Normal Open
                setcheckdata(0);
                setDataCopy({...dataCopy, [obj_key]: 0})
            }
            else{
                setcheckdata(1);
                setDataCopy({...dataCopy, [obj_key]: 1})

                // update SOFC, add alarm messge CV380 must be open / CV110 must be open, by sumin 2403xx
                if(obj_key === 30460){ // VSD110 POWER
                    setPSM1RunStop110Alarm('PSM1 CV713 must be CLOSE');
                }else if (obj_key === 31867){
                    setPSM2RunStop110Alarm('PSM2 CV713 must be CLOSE');
                }else if (obj_key === 33274){
                    setPSM3RunStop110Alarm('PSM3 CV713 must be CLOSE');
                }else if (obj_key === 34681){
                    setPSM4RunStop110Alarm('PSM4 CV713 must be CLOSE');
                }else if (obj_key === 36088){
                    setPSM5RunStop110Alarm('PSM5 CV713 must be CLOSE');
                }

                // if(obj_key === 164360 ){
                //     setPSM1RunStop380Alarm('CV380 must be OPEN');
                // }else if(obj_key === 264360){
                //     setPSM2RunStop380Alarm('CV380 must be OPEN');
                // }else if(obj_key === 364360 ){
                //     setPSM3RunStop380Alarm('CV380 must be OPEN');
                // }else if(obj_key === 464360){
                //     setPSM4RunStop380Alarm('CV380 must be OPEN');
                // }else if(obj_key === 564360){
                //     setPSM5RunStop380Alarm('CV380 must be OPEN');
                // }else if(obj_key === 164280){
                //     setPSM1RunStop110Alarm('CV105 must be OPEN');
                // }else if(obj_key === 264280){
                //     setPSM2RunStop110Alarm('CV105 must be OPEN');
                // }else if(obj_key === 364280){
                //     setPSM3RunStop110Alarm('CV105 must be OPEN');
                // }else if(obj_key === 464280){
                //     setPSM4RunStop110Alarm('CV105 must be OPEN');
                // }else if(obj_key === 564280){
                //     setPSM5RunStop110Alarm('CV105 must be OPEN');
                // }
            }

            // setDataCopy({...dataCopy, [obj_key]: 1});
        }
        else if( event.target.id === "0"){    
            // update SOFC 250513, CLD001STATUS~CLD003STATUS normal open
            if( obj_key === 10258 || obj_key === 10252 || obj_key === 30451 ||
                obj_key === 14172 || obj_key === 14166 || obj_key === 31858 ||
                obj_key === 18086 || obj_key === 18080 || obj_key === 33265 ||
                obj_key === 22000 || obj_key === 21994 || obj_key === 34672 ||
                obj_key === 25914 || obj_key === 25908 || obj_key === 36079 ||
                obj_key === 3680 || obj_key === 3683 || obj_key === 3686 || obj_key === 3689 || obj_key === 3692 || obj_key === 3695 ||
                obj_key === 3698 || obj_key === 3701 || obj_key === 3704 || obj_key === 3707 || obj_key === 3710 || obj_key === 3713 ||
                obj_key === 3716 || obj_key === 3719 || obj_key === 3722 ||
                obj_key === 30689 || obj_key === 30690 || obj_key === 30691 || obj_key === 32096 || obj_key === 32097 || obj_key === 32098 ||
                obj_key === 33503 || obj_key === 33504 || obj_key === 33505 || obj_key === 34910 || obj_key === 34911 || obj_key === 34912 ||
                obj_key === 36317 || obj_key === 36318 || obj_key === 36319
                ){
                setcheckdata(1);
                setDataCopy({...dataCopy, [obj_key]: 1})
            }
            else{
                setcheckdata(0);
                setDataCopy({...dataCopy, [obj_key]: 0})
                
                // update SOFC, add alarm messge CV380 must be open / CV110 must be open, by sumin 2403xx
                if(obj_key === 30460){ // VSD110 POWER
                    setPSM1RunStop110Alarm('PSM1 CV713 must be CLOSE');
                }else if (obj_key === 30460){
                    setPSM2RunStop110Alarm('PSM2 CV713 must be CLOSE');
                }else if (obj_key === 33274){
                    setPSM3RunStop110Alarm('PSM3 CV713 must be CLOSE');
                }else if (obj_key === 34681){
                    setPSM4RunStop110Alarm('PSM4 CV713 must be CLOSE');
                }else if (obj_key === 36088){
                    setPSM5RunStop110Alarm('PSM5 CV713 must be CLOSE');
                }
            }
            // setDataCopy({...dataCopy, [obj_key]: 0});
        }
    }

    // normal open
    const getCheckEnable = (id) => {
        if(typeof dataCopy !== 'undefined' && id in dataCopy){
            if(id === 10258 || id === 10252 || id === 30451 ||
                id === 14172 || id === 14166 || id === 31858 ||
                id === 18086 || id === 18080 || id === 33265 ||
                id === 22000 || id === 21994 || id === 34672 ||
                id === 25914 || id === 25908 || id === 36079 ||
                id === 3680 || id === 3683 || id === 3686 || id === 3689 || id === 3692 || id === 3695 ||
                id === 3698 || id === 3701 || id === 3704 || id === 3707 || id === 3710 || id === 3713 ||
                id === 3716 || id === 3719 || id === 3722 ||
                id === 30689 || id === 30690 || id === 30691 || id === 32096 || id === 32097 || id === 32098 ||
                id === 33503 || id === 33504 || id === 33505 || id === 34910 || id === 34911 || id === 34912 ||
                id === 36317 || id === 36318 || id === 36319
            ){
                return dataCopy[id] === 0;
            }
            else{
                return dataCopy[id] === 1;
            }
        }
        else {
            if( id === 10258 || id === 10252 || id === 30451 ||
                id === 14172 || id === 14166 || id === 31858 ||
                id === 18086 || id === 18080 || id === 33265 ||
                id === 22000 || id === 21994 || id === 34672 ||
                id === 25914 || id === 25908 || id === 36079 ||
                id === 3680 || id === 3683 || id === 3686 || id === 3689 || id === 3692 || id === 3695 ||
                id === 3698 || id === 3701 || id === 3704 || id === 3707 || id === 3710 || id === 3713 ||
                id === 3716 || id === 3719 || id === 3722 ||
                id === 30689 || id === 30690 || id === 30691 || id === 32096 || id === 32097 || id === 32098 ||
                id === 33503 || id === 33504 || id === 33505 || id === 34910 || id === 34911 || id === 34912 ||
                id === 36317 || id === 36318 || id === 36319
            ){
                return data[id] === 0;
            }
            else{
                return data[id] === 1;
            }

        }
    }

    const getCheckDisable= (id) => {
        if(typeof dataCopy !== 'undefined' && id in dataCopy){
            if( id === 10258 || id === 10252 || id === 30451 ||
                id === 14172 || id === 14166 || id === 31858 ||
                id === 18086 || id === 18080 || id === 33265 ||
                id === 22000 || id === 21994 || id === 34672 ||
                id === 25914 || id === 25908 || id === 36079 ||
                id === 3680 || id === 3683 || id === 3686 || id === 3689 || id === 3692 || id === 3695 ||
                id === 3698 || id === 3701 || id === 3704 || id === 3707 || id === 3710 || id === 3713 ||
                id === 3716 || id === 3719 || id === 3722 ||
                id === 30689 || id === 30690 || id === 30691 || id === 32096 || id === 32097 || id === 32098 ||
                id === 33503 || id === 33504 || id === 33505 || id === 34910 || id === 34911 || id === 34912 ||
                id === 36317 || id === 36318 || id === 36319
            ){
                return dataCopy[id] === 1;
            }
            else{
                return dataCopy[id] === 0;
            }
        }
        else {
            if( id === 10258 || id === 10252 || id === 30451 ||
                id === 14172 || id === 14166 || id === 31858 ||
                id === 18086 || id === 18080 || id === 33265 ||
                id === 22000 || id === 21994 || id === 34672 ||
                id === 25914 || id === 25908 || id === 36079 ||
                id === 3680 || id === 3683 || id === 3686 || id === 3689 || id === 3692 || id === 3695 ||
                id === 3698 || id === 3701 || id === 3704 || id === 3707 || id === 3710 || id === 3713 ||
                id === 3716 || id === 3719 || id === 3722 ||
                id === 30689 || id === 30690 || id === 30691 || id === 32096 || id === 32097 || id === 32098 ||
                id === 33503 || id === 33504 || id === 33505 || id === 34910 || id === 34911 || id === 34912 ||
                id === 36317 || id === 36318 || id === 36319
            ){
                return data[id] === 1;
            }
            else{
                return data[id] === 0;
            }
        }
    }

    const displayBLOAlarm = (id) => {
        if (id === 30460 && data[30451] === 0){ // CV713이 OPEN이고 display id 12172 (VSD110 POWER)
            return PSM1runstop110Alarm;
        }else if (id === 31867 && data[31858] === 0){ // CV713이 OPEN이고 display id 12172 (VSD110 POWER)
            return PSM2runstop110Alarm;
        }else if (id === 33274 && data[33265] === 0){ // CV713이 OPEN이고 display id 12172 (VSD110 POWER)
            return PSM3runstop110Alarm;
        }else if (id === 34681 && data[34672] === 0){ // CV713이 OPEN이고 display id 12172 (VSD110 POWER)
            return PSM4runstop110Alarm;
        }else if (id === 36088 && data[36079] === 0){ // CV713이 OPEN이고 display id 12172 (VSD110 POWER)
            return PSM5runstop110Alarm;
        }

        // if (id === 164360 && data[106830] === 0){
        //     return PSM1runstop380Alarm
        // }else if (id === 264360 && data[206830] === 0){
        //     return PSM2runstop380Alarm
        // }else if (id === 364360 && data[306830]=== 0){
        //     return PSM3runstop380Alarm
        // }else if (id === 464360 && data[406830] === 0){
        //     return PSM4runstop380Alarm
        // }else if (id === 564360 && data[506830] === 0){
        //     return PSM5runstop380Alarm
        // }else if (id === 164280 && data[106770] === 0){
        //     return PSM1runstop110Alarm
        // }else if (id === 264280 && data[206770] === 0){
        //     return PSM2runstop110Alarm
        // }else if (id === 364280 && data[306770] === 0){
        //     return PSM3runstop110Alarm
        // }else if (id === 464280 && data[406770] === 0){
        //     return PSM4runstop110Alarm
        // }else if (id === 564280 && data[506770] === 0){
        //     return PSM5runstop110Alarm
        // }
    }

    // update 250328 disable Blower Override (CV713 OPEN -> VSD110 POWER ON )
    const disableBloOverride = (id, name) => {
        if(name === 'VSD110 POWER'){
            if(id === 30460 && data[30451] === 0){
                return true;
            }else if (id === 31867 && data[31858] === 0){
                return true;
            }else if (id === 33274 && data[33265] === 0){
                return true;
            }else if (id === 34681 && data[34672] === 0){
                return true;
            }else if (id === 36088 && data[36079] === 0){
                return true;
            }
        }
    }

    const gridColumn = _.times((1), (i) => (
        Object.keys(column).map(i => (
            column[i][0].page_name.includes('Analog I/O Override') || (column[i][0].tag_display_subgroup && column[i][0].tag_display_subgroup === 'HRM Analog I/O Override')  || column[i][0].page_name === 'H2 Sensors'  ?
            
                <Grid columns={column[i] && column[i].length >= 10 ? 10 : column[i].length} celled = 'internally' stackable padded style={styles.grid}>
                    {/** //update 241219, add condition of columns value*/}
                    {column[i].map(r =>
                    r.tag_display_name === 'TCPCRSWORD' || r.tag_display_name === 'H2_TCPCRSWORD' || r.tag_display_name === 'SVM_TCPCRSWORD' ||
                        r.tag_display_name === 'H2_COMMFAULT' || r.tag_display_name === 'SVM_COMMFAULT' || r.tag_display_name === 'CRTAGS' || r.tag_display_name.includes('CRSWORD') || r.tag_display_name.includes('COMMFAULT') ?
                        ''
                        : 
                        <Grid.Column style={{paddingTop: '0px', paddingBottom: '7px'}}>
                            <Grid.Column style={{paddingTop: '0px'}} >
                                {/** //update 241224 S300 Only, display MAIN_CM001~006 data */}
                                {r.tag_display_name === 'FT012' || r.tag_display_name === 'YAT910-CE' || r.tag_display_name === 'TE180R (FPC)' || 
                                    (r.tag_display_name && r.display_id === 110) && r.tag_display_name.startsWith('MAIN_') ||
                                    (r.tag_display_name && r.display_id === 210) && r.tag_display_name.startsWith('MAIN_') ||
                                    (r.tag_display_name && r.display_id === 310) && r.tag_display_name.startsWith('MAIN_') ||
                                    (r.tag_display_name && r.display_id === 410) && r.tag_display_name.startsWith('MAIN_') ||
                                    (r.tag_display_name && r.display_id === 510) && r.tag_display_name.startsWith('MAIN_')  ? // update SOFC, add disabled tag TE180R (FPC) by sumin, 2402xx
                                    <Button
                                        key='button'
                                        type='button'
                                        color='teal'
                                        compact
                                        disabled
                                        content={r.tag_display_name}/>
                                    :
                                    <Button
                                        key='button'
                                        type='button'
                                        color='teal'
                                        compact
                                        disabled={electronApp ? false : !isAuthorized(user.hmi_role, r.hmi_security)}
                                        content={r.tag_display_name}
                                        onClick={() => {
                                            setOpen({...open, [r.id]: true}) // {100: false, 490: false, 596: false, 746: false, 767: false}
                                        }}/>
                                }
                                <Modal
                                    key = {r.id}
                                    style = {styles.width}
                                    open = {open[r.id]}
                                    onClose={handleClose[r.id]}
                                    onOpen = {handleOpen[r.id]}>
                                    <Modal.Header>{title} </Modal.Header>
                                    <Modal.Description>
                                        <Header style={styles.header}>Enter Value for {r.tag_display_name} </Header>
                                    </Modal.Description>
                                    <Modal.Content>
                                   
                                        <form autoComplete='off' onSubmit={(event, value) => handleSubmit(event, r.id)}>
                                            <Input focus autoFocus placeholder='Value' style={styles.input}
                                                   name='Input change'
                                                   label = {r.unit || ""}
                                                   labelPosition='right'
                                                   type='number'
                                                   step ='0.00001'
                                                   size='small'
                                                   min ={r.min}
                                                   max ={r.max}
                                                   onChange={(event, value) => handleChange(event, value)}
                                                   defaultValue = {data[r.id]}
                                            />
                                        </form>
                                        <Button style = {{marginTop: '10px'}} color='blue' content={'Clear Overrides'} onClick={(event, value) => handleClear(event,r.id)}/>
                                    </Modal.Content>
                                    <Modal.Actions>
                                        <Button 
                                            color='blue' 
                                            content={'Ok'} 
                                            onClick={(event, value) => handleToggle(event,r.id)}
                                            disabled={disableBloOverride(r.id, r.tag_display_name)}
                                            />
                                        <Button 
                                            color='red' 
                                            content={'Cancel'} 
                                            onClick={() => handleClose(r.id)}/>
                                    </Modal.Actions>
                                </Modal>
                            </Grid.Column>
                            {/* // * id= 999, PAFC기준 LT5400, LT450, PT510이었음  */}
                            {/* // update SOFC 240321 by sumin, add condition : data[r.id] !== null추가 - null 값 들어갈 경우 analog override 화면 black screen 뜨는 오류 방지 위해    */}
                            <Grid.Column style ={{fontSize: '18px'}}> {typeof data[r.id] !== 'undefined' && data[r.id] !== null ? ((r.id === 99999 ) ? data[r.id].toFixed(3) : data[r.id].toFixed(2)) : ''} <span style={{color: '#04BFBF'}}>{r.unit} </span>
                            </Grid.Column>
                            <Grid.Column style={{color: '#f5c71a',paddingBottom: '0'}}> {tempovrdata[r.id]}
                                {(typeof tempoverridden !== 'undefined' && typeof tempoverridden[r.id] !== 'undefined' && tempoverridden[r.id] === 1 && overrideVisible.visible && r.isOverriden !== 1) ||                         
                                (r.isOverriden === 1 && overrideVisible.visible)?
                                    <Icon style={styles.overriden} name='asterisk' color='yellow' size='small' />
                                    : <Icon style={styles.overriden} name='asterisk' color='black' size='small' />}
                            </Grid.Column>
                        </Grid.Column>
                    )}
                        </Grid>
                        :
                        column[i][0].page_name.includes('Digital I/O Override') ? // update 240830, IAS : IAS Digital Override column value : 7, add condition
                            <Grid columns={column[i] && column[i].length < 10 ? column[i].length : 10} celled = 'internally' stackable padded style={styles.grid}>
                            {column[i].map(r =>
                                r.tag_display_name === 'IO_TCPCRSWORD' || r.tag_display_name === 'FAN151OBS' ||r.tag_display_name.includes('CRSWORD') || r.tag_display_name.includes('COMMFAULT')|| (option ===2 && r.tag_display_name === 'PMP400')?
                                '' :
                                <Grid.Column style={{paddingTop: '0px', paddingBottom: '7px'}}>
                                    <Grid.Column  style ={{paddingTop: '0px'}}>
                                        {/*//update SOFC 2403xx by sumin, add disabled tag BAT/PS/UPS001~005 in PSM override page */}
                                        {/*//update SOFC 2412xx by sumin, add disabled tag MAIN CLD, SUB CLD tags in digital override page  */}
                                        { r.tag_display_name === 'PAFC PS600' || r.tag_display_name === 'PAFC FS160' || (r.display_id === 111 && (r.tag_display_name === 'BAT001' || r.tag_display_name === 'PS001' || r.tag_display_name === 'UPS001'))
                                        || r.tag_display_name === 'RY140'
                                        || (r.display_id === 111 && r.tag_display_name ) && r.tag_display_name.startsWith('MAIN CLD') 
                                        || (r.display_id === 211 && r.tag_display_name ) && r.tag_display_name.startsWith('MAIN CLD') 
                                        || (r.display_id === 311 && r.tag_display_name ) && r.tag_display_name.startsWith('MAIN CLD') 
                                        || (r.display_id === 411 && r.tag_display_name ) && r.tag_display_name.startsWith('MAIN CLD') 
                                        || (r.display_id === 511 && r.tag_display_name ) && r.tag_display_name.startsWith('MAIN CLD') 
                                        || (r.display_id === 211 && (r.tag_display_name === 'BAT002' || r.tag_display_name === 'PS002' || r.tag_display_name === 'UPS002')) || (r.display_id === 311 && (r.tag_display_name === 'BAT003' || r.tag_display_name === 'PS003' || r.tag_display_name === 'UPS003'))
                                        || (r.display_id === 411 && (r.tag_display_name === 'BAT004' || r.tag_display_name === 'PS004' || r.tag_display_name === 'UPS004')) || (r.display_id === 511 && (r.tag_display_name === 'BAT005' || r.tag_display_name === 'PS005' || r.tag_display_name === 'UPS005'))? //PS600 and FS160
                                            <Button
                                                key='button'
                                                type='button'
                                                color='teal'
                                                compact
                                                disabled
                                                content={r.tag_display_name}/>
                                            :
                                            option === 2 && r.tag_display_name === 'PAFC VSD400' ?
                                                <>
                                                <Button
                                                    key='button'
                                                    type='button'
                                                    color='teal'   
                                                    compact
                                                    style={styles.textwrap}
                                                    disabled={electronApp ? false : !isAuthorized(user.hmi_role, r.hmi_security)}
                                                    content='PMP400'
                                                    onClick={() => {
                                                        setOpen({...open, [r.id]: true})
                                                    }}/>
                                                <Modal
                                                    key = {r.id}
                                                    style = {styles.width}
                                                    open = {open[r.id]}
                                                    onClose={handleClose[r.id]}
                                                    onOpen={handleOpen[r.id]}>
                                                    <Modal.Header>{title} </Modal.Header>
                                                    <Modal.Description>
                                                        <Header style={styles.header}>Enter Value for PMP400 </Header>
                                                    </Modal.Description>
                                                    <Modal.Content>
                                                        {/*<Input*/}
                                                        {/*    type = 'radio'*/}
                                                        {/*    id = {1}*/}
                                                        {/*    label = {CheckOnOp(r.tag_display_name)}*/}
                                                        {/*    checked={getCheckEnable(r.id)}*/}
                                                        {/*    onChange={(event, value) => handleCheck(event, r.id)}*/}
                                                        {/*    style = {styles.checkbox}*/}
                                                        {/*/>*/}
                                                        {/*<Input*/}
                                                        {/*    type = 'radio'*/}
                                                        {/*    id = {0}*/}
                                                        {/*    label = {CheckOffOp(r.tag_display_name)}*/}
                                                        {/*    checked={getCheckDisable(r.id)}*/}
                                                        {/*    onChange={(event, value) => handleCheck(event, r.id)}*/}
                                                        {/*    style = {styles.checkbox}*/}
                                                        {/*/>*/}
                                                        <Button.Group toggle>
                                                            <Button
                                                                size='medium'
                                                                id={1}
                                                                active={getCheckEnable(r.id)}
                                                                onClick={(event, value) => handleCheck(event, r.id)}
                                                                content={CheckOnOp(r.tag_display_name)}
                                                            />
                                                            <Button
                                                                size='medium'
                                                                id={0}
                                                                active={getCheckDisable(r.id)}
                                                                onClick={(event, value) => handleCheck(event, r.id)}
                                                                content={CheckOffOp(r.tag_display_name)}
                                                            />
                                                        </Button.Group>
                                                        <Button style = {{marginTop: '10px'}} color='blue' content={'Clear Overrides'} onClick={(event, value) => handleDigClear(event, r.id, currentPLC)}/>
                                                    </Modal.Content>
                                                    <Modal.Actions style = {styles.toggle}>
                                                        <Button 
                                                            color='blue' 
                                                            content={'Ok'} 
                                                            onClick={(event, value) => handleDigToggle(event, r.id, currentPLC)}/>
                                                        <Button color='red' content={'Cancel'} onClick={() => handleClose(r.id)}/>
                                                    </Modal.Actions>
                                                </Modal>
                                                </>
                                                :
                                                <>
                                                <Button
                                                    key='button'
                                                    type='button'
                                                    color='teal'
                                                    compact
                                                    style={styles.textwrap}
                                                    disabled={electronApp ? false : !isAuthorized(user.hmi_role, r.hmi_security)}
                                                    content={r.tag_display_name}
                                                    onClick={() => {
                                                        setOpen({...open, [r.id]: true})
                                                    }}/>
                                                    <Modal
                                                        key = {r.id}
                                                        style = {styles.width}
                                                        open = {open[r.id]}
                                                        onClose={handleClose[r.id]}
                                                        onOpen={handleOpen[r.id]}>
                                                    <Modal.Header>{title} </Modal.Header>
                                                    <Modal.Description>
                                                        <Header style={styles.header}>Enter Value
                                                            for {r.tag_display_name} </Header>
                                                                {/** //update SOFC, to add alarm message - CV110, CV380 by sumin 240318 */}
                                                                {(r.tag_display_name === 'VSD110 POWER') ? <h4 style={{color : 'red', marginLeft : '10px'}}> {displayBLOAlarm(r.id)} </h4> : '' } 
                                                            
                                                    </Modal.Description>
                                                    <Modal.Content>
                                                    {/*<Input*/}
                                                    {/*type = 'radio'*/}
                                                    {/*id = {1}*/}
                                                    {/*label = {CheckOnOp(r.tag_display_name)}*/}
                                                    {/*checked={getCheckEnable(r.id)}*/}
                                                    {/*onChange={(event, value) => handleCheck(event, r.id)}*/}
                                                    {/*style = {styles.checkbox}*/}
                                                    {/*/>*/}
                                                    {/*<Input*/}
                                                    {/*type = 'radio'*/}
                                                    {/*id = {0}*/}
                                                    {/*label = {CheckOffOp(r.tag_display_name)}*/}
                                                    {/*checked={getCheckDisable(r.id)}*/}
                                                    {/*onChange={(event, value) => handleCheck(event, r.id)}*/}
                                                    {/*style = {styles.checkbox}*/}
                                                    {/*/>*/}
                                                        <Button.Group toggle>
                                                            <Button
                                                                size='medium'
                                                                id={1}
                                                                active={getCheckEnable(r.id)}
                                                                onClick={(event, value) => handleCheck(event, r.id)}
                                                                content={CheckOnOp(r.tag_display_name)}
                                                            />
                                                            <Button
                                                                size='medium'
                                                                id={0}
                                                                active={getCheckDisable(r.id)}
                                                                onClick={(event, value) => handleCheck(event, r.id)}
                                                                content={CheckOffOp(r.tag_display_name)}
                                                            />
                                                        </Button.Group>
                                                    <Button 
                                                        style = {{marginTop: '10px'}} 
                                                        color='blue' 
                                                        content={'Clear Overrides'} 
                                                        onClick={(event, value) => handleDigClear(event, r.id, currentPLC)}
                                                        
                                                    />
                                                    </Modal.Content>
                                                    <Modal.Actions style = {styles.toggle}>
                                                        <Button 
                                                            color='blue' 
                                                            content={'Ok'} 
                                                            onClick={(event, value) => handleDigToggle(event, r.id, currentPLC)}
                                                            disabled={disableBloOverride(r.id, r.tag_display_name)} // update 250328 disable vsd110 power override button
                                                            />
                                                        <Button color='red' content={'Cancel'} onClick={() => handleClose(r.id)}/>
                                                    </Modal.Actions>
                                                    </Modal>
                                                </>
                                        }
                                    </Grid.Column> 
                                    {/** //update SOFC S00 250305, CLD display MAIN CLD001 STATUS ~003 */}
                                    {(convertValue(data[r.id], r.tag_display_name) === 'ON' 
                                         && !r.tag_display_name.includes('MAIN CLD001 STATUS') && !r.tag_display_name.includes('MAIN CLD002 STATUS') && !r.tag_display_name.includes('MAIN CLD003 STATUS') 
                                         && !r.tag_display_name.includes('CLD001STATUS') && !r.tag_display_name.includes('CLD002STATUS') && !r.tag_display_name.includes('CLD003STATUS')
                                            ) || 
                                        (r.tag_display_name.includes('MAIN CLD001 STATUS') || r.tag_display_name.includes('MAIN CLD002 STATUS') || r.tag_display_name.includes('MAIN CLD003 STATUS') ||
                                            r.tag_display_name.includes('CLD001STATUS') || r.tag_display_name.includes('CLD002STATUS') || r.tag_display_name.includes('CLD003STATUS')) 
                                        && (convertValue(data[r.id], r.tag_display_name) === 'OFF')
                                        ||(convertValue(data[r.id], r.tag_display_name) === 'OPEN' && (r.tag_display_name !== 'CV720' && r.tag_display_name !== 'CV710' && r.tag_display_name !== 'CV713' && r.tag_display_name !== 'CV710')) 
                                        ||  ((r.tag_display_name === 'CV720' || r.tag_display_name === 'CV710' || r.tag_display_name === 'CV713') && convertValue(data[r.id], r.tag_display_name) === 'CLOSED' ) ?
                                        (<Grid.Column style ={{fontSize: '18px', color: 'green', fontWeight: 'bold'}}> {convertValue(data[r.id], r.tag_display_name)} </Grid.Column>)
                                                : (<Grid.Column style ={{fontSize: '18px'}}> {convertValue(data[r.id], r.tag_display_name)}
                                                </Grid.Column>)
                                    }
                                    <Grid.Column style={{color: '#f5c71a',paddingBottom: '0'}}> {convertValue(tempovrdata[r.id], r.tag_display_name)}
                                        {(typeof tempoverridden !== 'undefined' && typeof tempoverridden[r.id] !== 'undefined' && tempoverridden[r.id] === 1 && overrideVisible.visible && r.isOverriden !== 1) ||
                                        (r.isOverriden === 1 && overrideVisible.visible)?
                                            <Icon style={styles.overriden} name='asterisk' color='yellow' size='small' />
                                            : <Icon style={styles.overriden} name='asterisk' color='black' size='small' />}
                                        </Grid.Column>
                                </Grid.Column>
                            )}
                            </Grid>
                        :
                         <Grid centered padded style={styles.grid}>
                                <Grid.Column>
                                    <p>{column[i][0].tag_display_subgroup}</p>
                                    {column[i].map(r =>
                                        <Grid.Row key={r.id} style = {styles.grid}>
                                            <Grid.Column style={styles.name}>{r.name}</Grid.Column>
                                            <Grid.Column>{data[r.id]} {r.unit} </Grid.Column>
                                        </Grid.Row>
                                    )}
                            </Grid.Column>
                        </Grid>
                    ))
                ))

    return (
        <div>
            <Grid.Row key={index} style={{ maxWidth: '1800px', padding: '2px 0',margin:'0' }}>
                {gridColumn}
            </Grid.Row>
        </div>
    );
};

const styles = {
    grid: {
        margin: '0',
        paddingBottom: '0'
    },
    row: {
        padding: '2px 0'
    },
    name: {
        color: 'yellow'
    },
    input: {
        width: '150px'
    },
    width: {
        maxWidth: '300px'
    },
    header: {
        marginTop: '20px',
        marginLeft: '10px'
    },
    toggle: {
        marginLeft: '8px'
    },
    checkbox: {
        flexDirection: 'row-reverse',
        marginLeft: '10px'
    },
    overriden: {
        marginLeft: '15px'
    },
    textwrap: {
        whiteSpace: 'pre-wrap',
        overflowWrap: 'break-word'
    }
};

export default React.memo(IOColumn);